import request from '@/utils/request'

let BASEROOT          = '/visitor/v2'

// 团体预登记（为同事预登记）
// 团体预登记列表
export function teamList(data) {
  return request({
    url: BASEROOT + '/account/team/listTeamVisitor',
    method: 'post',
    data
  })
}

// 团体预登记新增接口
export function teamAdd(data) {
    return request({
      url: BASEROOT + '/account/team/addTeamVisitor',
      method: 'post',
      data
    })
  }

// 团体预登记修改接口
export function teamUpdate(data) {
    return request({
      url: BASEROOT + '/account/team/updateTeamVisitor',
      method: 'post',
      data
    })
  }

// 团体预登记详情接口
export function teamDetail(data) {
    return request({
      url: BASEROOT + '/account/team/getTeamVisitorDetail',
      method: 'post',
      data
    })
  }